import { render, staticRenderFns } from "./WaitReport.vue?vue&type=template&id=4b1c838f&scoped=true"
import script from "./WaitReport.vue?vue&type=script&lang=js"
export * from "./WaitReport.vue?vue&type=script&lang=js"
import style0 from "./WaitReport.vue?vue&type=style&index=0&id=4b1c838f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c838f",
  null
  
)

export default component.exports